/**
 * Blur-commit for a required text field: commits the trimmed draft when it
 * changed, and resets an emptied draft back to the synced value instead of
 * committing (the field can be rewritten, never cleared). Shaped for
 * `useClaimableDraft`'s commit callback.
 */
export function commitTrimmedDraft(
  synced: string,
  commit: (next: string) => void,
): (draft: string, reset: (value: string) => void) => void {
  return (draft, reset) => {
    const next = draft.trim();
    if (next && next !== synced) commit(next);
    else if (!next) reset(synced);
  };
}
